import angular from 'angular';

const app = angular.module('klTenantConfig', []).constant('config', TENANT_CONFIG);

export default app.name;
